// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1cnqr","content":"styles_content__26ei1","textInputWidthDefault":"styles_textInputWidthDefault__2RTzI","flexButton":"styles_flexButton__2oqz_"};